@if (state$ | async; as state) {
  <div class="search-container">
    <app-wallet-select
      [id]="'list-ind-wallet-select'"
      class="wallet-select"
      [(ngModel)]="selectedWallet"
      [disabled]="state.isLoading"
      [enableAutoSelect]="true"
      (selectionChange)="onWalletChange($event.value?.id)"
      data-testid="wallet-select"
      />
      <div class="document-search-wrapper">
        <app-search-input
          [id]="'list-ind-search-input'"
          [inputLabel]="documentInputSearchLabel"
          [placeholder]="'Buscar documento'"
          [formControl]="filterService.getForm().get('document')"
          [disabledSearch]="state.isLoading"
          [customValidator]="documentValidator"
          (searchTriggered)="onSearchTriggered()"
          [mask]="documentSearchMask"
        ></app-search-input>
      </div>
      @if (showAdminActions && !isAlert30DaysWallet()) {
        <app-button
          [id]="'list-ind-btn-add'"
          (click)="handleNewDocumentShortcutClick()"
          icon="add"
          [buttonStyle]="'danger'"
          size="large"
          title="Incluir documento"
          i18n="@@include"
          >
      Incluir
    </app-button>
      }
      <app-button
        [id]="'list-ind-btn-massive-load'"
        [buttonStyle]="'danger'"
        style="flex-shrink: 0"
        size="large"
        title="Realizar carga masiva"
        i18n-title="@@performMassiveLoad"
        (click)="handleMassiveLoadShortcutClick()"
        >
        <img src="{{ urlAssets }}/icons/cargamasiva.png" alt="Carga massiva" style="width: 24px" />
        <span i18n="@@massiveLoadLabel">Carga masiva</span>
      </app-button>
    </div>
    <div class="up-table-container">
      <div class="report-button-container">
        <app-button
          [id]="'list-ind-btn-filters'"
          (click)="toggleFilterFields()"
          [icon]="(showFilterFields$ | async) ? 'close' : 'filter_outlined'"
          [buttonStyle]="(showFilterFields$ | async) ? 'danger' : 'outline'"
          size="large"
          i18n="@@advancedFilters"
          >
        Filtros avanzados
      </app-button>
        <app-button
          [id]="'list-ind-btn-report'"
          (click)="reportPerson(state.total)"
          icon="download"
          [buttonStyle]="'outline'"
          size="large"
          i18n="@@generateReport"
          [disabled]="state.isLoading || !state.items.length"
          >
        Generar reporte
      </app-button>
      </div>
    </div>
    <app-advanced-filters
      id="list-ind-advanced-filters"
      [buttonsDisabled]="state.isLoading"
      [showFilters]="showFilterFields$ | async"
      >
    </app-advanced-filters>
    <div class="table-responsive">
      <app-filter-tags id="list-ind-filter-tags"></app-filter-tags>
      <app-generic-table
        [id]="'list-ind-table'"
        [config]="tableConfig"
        [data]="state.items"
        [isLoading]="state.isLoading"
        [noDataMessage]="noDataMessage"
        [page]="state.page"
        [pageSize]="state.pageSize"
        [totalRegisters]="state.total"
        (pageChange)="changePage($event)"
        >
        <ng-template appTableCell="_icon" let-trackingRegistry>
          @if (personType === 'COMPANY') {
            <div>
              <img
                style="max-width: 30px"
                src="{{ urlAssets }}/icons/company-select.png"
                alt="Dinamica"
                />
              </div>
            }
            @if (personType !== 'COMPANY') {
              <div>
                <img
                  style="max-width: 30px"
                  src="{{ urlAssets }}/icons/persona-select.png"
                  alt="Dinamica"
                  />
                </div>
              }
            </ng-template>
            <ng-template appTableCell="name" let-trackingRegistry>
              {{ getPersonName(trackingRegistry) }}
            </ng-template>
            <ng-template appTableCell="document" let-trackingRegistry>
              @if (personType === 'PERSON') {
                <span>{{ trackingRegistry.document | cpfMask }}</span>
              }
              @if (personType === 'COMPANY') {
                <span>{{ trackingRegistry.document | cnpjMask }}</span>
              }
            </ng-template>
            <ng-template appTableCell="_wallets" let-trackingRegistry>
              <a (click)="handleShowWallets(trackingRegistry)" class="clickable-link">
                {{ trackingRegistry.wallets.length }}
              </a>
            </ng-template>
            <ng-template appTableCell="internalCode" let-trackingRegistry>
              {{ trackingRegistry.internalCode !== '' ? trackingRegistry.internalCode : '-' }}
            </ng-template>
            <ng-template appTableCell="segment" let-trackingRegistry>
              {{ trackingRegistry.segment !== '' ? trackingRegistry.segment : '-' }}
            </ng-template>
            <ng-template appTableCell="totalRestrictive" let-trackingRegistry>
              @if (trackingRegistry.totalRestrictive > 0) {
                <a
                  (click)="handleShowIndicators(trackingRegistry)"
                  class="clickable-link"
                  >
                  {{ trackingRegistry.totalRestrictive | thousandsMask }}
                </a>
              } @else {
                {{ trackingRegistry.totalRestrictive || '-' }}
              }
            </ng-template>
            <ng-template appTableCell="_actions" let-trackingRegistry>
              <app-tracking-registry-actions
                [item]="trackingRegistry"
                [showAdminActions]="showAdminActions"
                [isAlert30DaysWallet]="isAlert30DaysWallet()"
                (actionClick)="onTrackingRegistryAction($event)"
                >
              </app-tracking-registry-actions>
            </ng-template>
          </app-generic-table>
        </div>
      }
